import Image from 'next/image'
import styled from 'styled-components'

import { DozerLoading } from '../shared-components/DozerLoading'

import logo from 'public/buildpass.svg'

const Loading = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  width: 100%;
  height: 100%;
  ${({ theme }) => theme.font.label02}
  color: ${({ theme }) => theme.colour.secondary._900};
`

type Props = {
  text?: string
  showLogo?: boolean
}

export const CorePageLoading: React.FC<Props> = ({
  text = 'Loading',
  showLogo,
}) => {
  return (
    <Loading>
      <DozerLoading text={text} loading size={32} relative noBackground />
      {showLogo && (
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            marginTop: '-20px',
          }}
        >
          <Image src={logo.src} alt="BuildPass" width={90} height={23} />
        </div>
      )}
    </Loading>
  )
}
